import React from 'react';
import { Lead } from '../../../../types';
import { DetailRow } from './DetailRow';
import { MetaLogoIcon } from '../../../../components/icons/CustomIcons';
import { Flag, Layers, FileText } from 'lucide-react';

interface LeadOriginTabProps {
    lead: Lead;
    onChange?: (name: string, value: string) => void;
}

type OriginDetailProps = {
    label: string;
    value: string;
    icon: React.ReactNode;
};

const OriginDetail: React.FC<OriginDetailProps> = ({ label, value, icon }) => (
    <li className="flex gap-s3 p-s3">
        <span className="mt-s1 shrink-0 text-muted" aria-hidden>
            {icon}
        </span>
        <div className="min-w-0">
            <p className="mb-s1 text-xs text-muted">{label}</p>
            <p className="text-sm font-medium leading-snug text-default">{value}</p>
        </div>
    </li>
);

export const LeadOriginTab: React.FC<LeadOriginTabProps> = ({ lead }) => {
    const isMetaAds =
        lead.origin === 'Meta Ads' ||
        Boolean(
            lead.originDetails &&
                (lead.originDetails.campaign || lead.originDetails.adSet || lead.originDetails.ad),
        );

    return (
        <section aria-label="Origem da negociação" className="space-y-s6">
            <header className="flex items-center justify-between gap-s3">
                <h3 className="text-sm font-medium text-default">Origem</h3>
                {isMetaAds ? (
                    <span className="badge badge-info inline-flex items-center gap-s1">
                        <MetaLogoIcon className="size-3.5" aria-hidden />
                        Meta Ads
                    </span>
                ) : (
                    <span className="text-sm font-medium text-default">{lead.origin || '—'}</span>
                )}
            </header>

            {isMetaAds && lead.originDetails ? (
                <ul
                    className="m-0 list-none overflow-hidden rounded-lg border border-subtle bg-surface-0 p-0"
                    aria-label="Detalhes Meta Ads"
                >
                    {lead.originDetails.campaign ? (
                        <OriginDetail
                            label="Campanha"
                            value={lead.originDetails.campaign}
                            icon={<Flag className="size-4" />}
                        />
                    ) : null}
                    {lead.originDetails.adSet ? (
                        <OriginDetail
                            label="Conjunto"
                            value={lead.originDetails.adSet}
                            icon={<Layers className="size-4" />}
                        />
                    ) : null}
                    {lead.originDetails.ad ? (
                        <OriginDetail
                            label="Anúncio"
                            value={lead.originDetails.ad}
                            icon={<FileText className="size-4" />}
                        />
                    ) : null}
                </ul>
            ) : null}

            <dl className="m-0">
                <DetailRow label="Entrou em">
                    <time
                        className="font-mono text-sm font-medium tabular-nums text-default"
                        dateTime={lead.entryDate}
                    >
                        {new Date(lead.entryDate).toLocaleString('pt-BR')}
                    </time>
                </DetailRow>
            </dl>
        </section>
    );
};
